import script from "./FormSelectOption.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormSelectOption.vue?vue&type=script&lang=ts&setup=true"

import "./FormSelectOption.vue?vue&type=style&index=0&id=7b88f9d1&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b88f9d1"]])

export default __exports__